module.exports = __webpack_public_path__ + "img/215.225c4a75.jpg";